import Swiper from 'swiper';
import { Navigation, Pagination, EffectCreative, Autoplay, Scrollbar } from 'swiper/modules';
Swiper.use([Pagination, Navigation, EffectCreative, Autoplay, Scrollbar]);

document.querySelectorAll('.video-slider').forEach((slider) => {
  const slides = slider.querySelectorAll('.swiper-slide');

  if (slides.length === 1) {
    const clone = slides[0].cloneNode(true);
    clone.style.visibility = 'hidden';
    clone.style.pointerEvents = 'none'; // prevent any accidental interaction
    slider.querySelector('.swiper-wrapper').appendChild(clone);
  }

  const videoSwiper = new Swiper(slider, {
    spaceBetween: 50,
    slidesPerView: 1,
    loop: true, // now safe because we force 2 slides
    breakpoints: {
      900: {
        slidesPerView: 2,
      },
    },
    pagination: {
      el: slider.closest('.slider_wrapper').querySelector('.video-pagination'),
    },
    navigation: {
      nextEl: slider.closest('.slider_wrapper').querySelector('.video-swiper-button-next'),
      prevEl: slider.closest('.slider_wrapper').querySelector('.video-swiper-button-prev'),
    },
  });
});
